var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.309,
    height: 68.03,
    viewBox: "0 0 52.309 68.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48bfe3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.333 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.353,22.01H94.209V15.721a15.721,15.721,0,0,0-31.443,0V22.01H59.622A6.287,6.287,0,0,0,53.333,28.3V59.742a6.287,6.287,0,0,0,6.289,6.288H97.353a6.287,6.287,0,0,0,6.289-6.289V28.3A6.287,6.287,0,0,0,97.353,22.01Zm-18.866,28.3a6.289,6.289,0,1,1,6.289-6.288A6.287,6.287,0,0,1,78.487,50.309Zm9.747-28.3H68.74V15.721a9.747,9.747,0,0,1,19.494,0Z",
    transform: "translate(-53.333)",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "url(#a)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock1);
export default __webpack_public_path__ + "static/media/padlock (1).9c7a0c23f9f54b9bb74d991b5bd37b04.svg";
export { ForwardRef as ReactComponent };